import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table, Card, Dropdown, Loader} from 'semantic-ui-react';
import {pageSizes} from '../../../common/constants/lists';
import {Actions} from '../../../common/actions';
import TablePaginator from '../../../common/components/tablePaginator';

class Detail extends Component {
  onPageClick = (value) => {
    this.props.changeImmobilizedDealeOrdersPage(value);
  }

  onPageSizeClick = (event, data) => {
    this.props.changeImmobilizedDealeOrdersPageSize(data.value);
  }

  renderBody() {
    const {orderDetail} = this.props;
    if (!orderDetail.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={13}>
            No hay datos disponibles
          </Table.Cell>
        </Table.Row>
      );
    }

    return orderDetail.map((element, index) => {
      return (
        <Table.Row textAlign='center' key={index}>
          <Table.Cell>{element.order}</Table.Cell>
          <Table.Cell>{element.chassis}</Table.Cell>
          <Table.Cell>{element.status}</Table.Cell>
          <Table.Cell>{element.quantity}</Table.Cell>
          <Table.Cell>{element.totalPrice}</Table.Cell>
        </Table.Row>
      );
    });
  }


  renderPagination() {
    const {pageNumber, pageSize, totalItems} = this.props;

    if (totalItems <= pageSize) {
      return null;
    }

    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell colSpan='100%'>
            <div className='table-pagination'>
              <span className='page-sizer'>
                <strong>Items por página</strong>
                <Dropdown
                  selection
                  upward
                  compact
                  value={pageSize}
                  options={pageSizes}
                  onChange={this.onPageSizeClick}
                />
              </span>
              <TablePaginator
                itemsCount={totalItems}
                itemsPerPage={pageSize}
                selectedPage={pageNumber}
                onOptionClick={this.onPageClick}
              />
            </div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }

  render() {
    const {downloading, loading} = this.props;

    if (loading) {
      return (
        <Card raised fluid>
          <Loader active inline='centered'>Buscando...</Loader>
        </Card>
      );
    }

    if (downloading) {
      return (
        <Card raised fluid>
          <Loader active inline='centered'>Generando archivo...</Loader>
        </Card>
      );
    }

    return (
      <Card raised fluid>
        <Table striped>
          <Table.Header>
            <Table.Row textAlign='center'>
              <Table.HeaderCell>Orden</Table.HeaderCell>
              <Table.HeaderCell>Chassis</Table.HeaderCell>
              <Table.HeaderCell>Estado</Table.HeaderCell>
              <Table.HeaderCell>Cantidad</Table.HeaderCell>
              <Table.HeaderCell>Precio Total</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>{this.renderBody()}</Table.Body>
          {this.renderPagination()}
        </Table>
      </Card>

    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.dealerOrdersImmobilized.loading,
    'orderDetail': state.dealerOrdersImmobilized.page,
    'downloading': state.dealerOrdersImmobilized.downloading,
    'pageNumber': state.dealerOrdersImmobilized.pageNumber,
    'pageSize': state.dealerOrdersImmobilized.pageSize,
    'totalItems': state.dealerOrdersImmobilized.list.length,
  };
};

const {
  changeImmobilizedDealeOrdersPage,
  changeImmobilizedDealeOrdersPageSize,
} = Actions;

export default connect(mapStateToProps, {
  changeImmobilizedDealeOrdersPage,
  changeImmobilizedDealeOrdersPageSize,
})(Detail);
